var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-tip"},[_c('div',{staticClass:"icon-wrapper"},[_c('img',{attrs:{"src":require(("@/assets/" + _vm.iconPath))}})]),_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41944703","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/onboarding/BaseToolTip.vue
// module id = null
// module chunks = 